export default __webpack_public_path__ + "static/media/gallery_08.1e7d1224.jpg";